<div class="main-content row top-xs center-xs pt-0">
  <div class="col-xs-12" style="margin: 2rem 0;">
    <div class="text" style="margin: 1rem 0;"><span style="padding-bottom:100px;font-weight: bolder;">Please Select a Country</span></div>
    <div class="search">
      <input type="text" class="bg-search col-xs-12" placeholder="Search" />
    </div>
    <ng-scrollbar class="custom-scrollbar" style="height: 1050px" [pointerEventsDisabled]="false" visibility="always">
      <div class="tab-content-wrapper">
        <table>
          <tr *ngFor="let country of filteredCountries" (click)="select_country(country)">
            <td style="width: 300px;">
              <div class="image-cropper">
                <img src="{{ country.flag }}" alt="avatar" class="profile-pic">
              </div>
            </td>
            <td><b>{{country.name}}</b></td>
          </tr>
        </table>
      </div>
    </ng-scrollbar>
  </div>
</div>
